import React from "react";
import { Link } from "react-router-dom";
import "./StaticPages.css";

const retrySteps = [
  { id: "card", text: "Check card details or use another payment method." },
  { id: "billing", text: "Confirm billing information and selected plan." },
  { id: "retry", text: "Return to pricing and start checkout again." },
];

const PaymentFailed = () => {
  return (
    <section className="static-page-section">
      <div className="auto-container">
        <div className="static-hero">
          <span className="icon danger"><i className="la la-times"></i></span>
          <h1>Payment Failed</h1>
          <p>The payment could not be completed. No job posting access was added to the employer account.</p>
          <div className="static-actions">
            <Link to="/employee-plans" className="theme-btn btn-style-one">Try Again</Link>
            <Link to="/contact" className="theme-btn btn-style-three">Contact Support</Link>
          </div>
        </div>

        <div className="ls-widget">
          <div className="widget-title"><h4>What To Check</h4></div>
          <div className="widget-content">
            <ul className="static-list">
              {retrySteps.map((item) => <li key={item.id}>{item.text}</li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PaymentFailed;
